import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getTaskNotes(params) {
  return request({
    url: '/GetTaskNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Mission: params.Mission,
        Result: params.Result
      }
    }
  })
}

export function addTaskNotes(params) {
  return request({
    url: '/AddTaskNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8002,
      MessageID: btcguid(),
      Data: {
        Mission: params.Mission,
        Head: params.Head,
        HardNode: params.HardNode,
        Progress: params.Progress,
        Result: params.Result,
        Notes: params.Notes,
        CreatePerson: params.CreatePerson
      }
    }
  })
}

export function updateTaskNotes(params) {
  return request({
    url: '/UpdateTaskNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8003,
      MessageID: btcguid(),
      Data: {
        NoteID: params.NoteID,
        Mission: params.Mission,
        Head: params.Head,
        HardNode: params.HardNode,
        Progress: params.Progress,
        Result: params.Result,
        Notes: params.Notes
      }
    }
  })
}

export function deleteTaskNotes(params) {
  return request({
    url: '/DeleteTaskNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8004,
      MessageID: btcguid(),
      Data: {
        NoteID: params.NoteID
      }
    }
  })
}

export function sortTaskNote(params) {
  return request({
    url: '/SortTaskNote',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8005,
      MessageID: btcguid(),
      Data: {
        Tasks: params.Tasks
      }
    }
  })
}

export function getTaskNewNotes(params) {
  return request({
    url: '/GetTaskNewNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8006,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function emptyTaskNotes(params) {
  return request({
    url: '/EmptyTaskNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 8007,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/notes.js